import { validCallbacks } from '../config';

export function isValidUrl(str) {
  return /^https?:\/\/[a-z0-9]+([-.]{1}[a-z0-9]+)*(:\d+)?(\/[^?]*)?$/.test(str);
}

export function isValidCallbackUrl(str) {
  return isValidUrl(str) &&
    validCallbacks.some((comp) => {
      if (comp instanceof RegExp) {
        return comp.test(str);
      }

      return str === comp;
    });
}

export function isValidEmail(str) {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(str);
}

export function sanitizePassword(str) {
  if (typeof str === 'string') {
    return str.replace(/\s/g, '');
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/rules/index.js